<main class="oauth">
  @if (isLoading) {
    <section class="oauth-card oauth-card--loading">
      <div class="oauth-loading"></div>
    </section>
  } @else if (consent) {
    <section class="oauth-card">
      <header class="oauth-header">
        <h1>
          <span class="oauth-app-name">{{ consent.client.name }}</span>
          {{ 'oauth.consent.heading' | translate }}
        </h1>
      </header>

      @if (userName()) {
        <div class="oauth-user">
          <div class="oauth-avatar">
            <app-avatar [seed]="consent.user.email || consent.user.name || consent.user.phone"></app-avatar>
          </div>
          <div class="oauth-user-details">
            <strong>{{ userName() }}</strong>

            @if (userContact()) {
              <span>{{ userContact() }}</span>
            }
          </div>
        </div>
      }

      @if (isClientVerified()) {
        <div class="oauth-about">
          <div class="oauth-app-icon oauth-app-icon--with-image">
            <img [src]="consent.client.icon_url" alt="" />
          </div>

          <div class="oauth-about-copy">
            <strong>
              {{ 'oauth.consent.aboutHeading' | translate }}
              <span class="oauth-app-name">{{ consent.client.name }}</span>
            </strong>
            <p>{{ consent.client.description }}</p>
          </div>
        </div>
      }

      @if (consent.scopes.length) {
        <div class="oauth-scopes">
          <h2>{{ 'oauth.consent.scopesHeader' | translate }}</h2>

          <div class="oauth-scope-list">
            @for (scope of consent.scopes; track scope.id) {
              <div
                class="oauth-scope"
                role="button"
                tabindex="0"
                [class.oauth-scope--disabled]="isSubmitting"
                (click)="toggleScope(scope.id)"
                (keydown.enter)="toggleScope(scope.id)"
                (keydown.space)="toggleScope(scope.id); $event.preventDefault()"
              >
                <app-switch [(ngModel)]="selectedScopes[scope.id]" [name]="'oauth-scope-' + scope.id" [disabled]="isSubmitting" (click)="$event.stopPropagation()"></app-switch>
                <span>{{ scopeDescription(scope) }}</span>
              </div>
            }
          </div>
        </div>
      }

      <div class="oauth-trust-section">
        <div class="oauth-trust">
          <strong>
            {{ 'oauth.consent.trustHeading' | translate }}
            <span class="oauth-app-name">{{ consent.client.name }}</span>
          </strong>
          <p>{{ 'oauth.consent.trustDescription' | translate }}</p>
        </div>

        @if (!isClientVerified()) {
          <div class="alertMessage size-S warning oauth-unverified-warning">
            <i class="fa-regular fa-circle-info"></i>
            <div>
              <p class="alertMessage__title">{{ 'oauth.consent.unverifiedTitle' | translate }}</p>
              <span>{{ 'oauth.consent.unverifiedDescription' | translate }}</span>
            </div>
          </div>
        }
      </div>

      <footer class="oauth-actions">
        <button class="btn-L btn-filled-cancel" type="button" [disabled]="isSubmitting" (click)="deny()">
          {{ 'oauth.consent.deny' | translate }}
        </button>
        <button class="btn-L btn-filled" type="button" [disabled]="isSubmitting" (click)="approve()">
          {{ 'oauth.consent.approve' | translate }}
        </button>
      </footer>
    </section>
  }
</main>
